<table mat-table [dataSource]="dataSource" class="ktbl-table-breite-komplett">

  <ng-container *ngFor="let column of displayedCols; let j = index" [matColumnDef]="column">

    <th mat-header-cell *matHeaderCellDef [ngClass]="{
      'ktbl-sub-table-header-base-neutral': true,
      'ktbl-typografie-reg-14-zwischenueberschrift': true,      
      'ktbl-table-allgemein-200-width': column === 'VORSCHAU_BILD',
      'ktbl-add-remove-width': column === 'ADD' || column === 'REMOVE'
    }">

      <ng-container *ngIf="column === 'VORSCHAU_BILD'">
        Bezeichnung /<br>Vorschaubild
      </ng-container>

      <ng-container *ngIf="column === 'WERT'">
        Beschreibung
      </ng-container>

      <ng-container *ngIf="column === 'ADD'">
        Hinzufügen
      </ng-container>

      <ng-container *ngIf="column === 'REMOVE'">
        Entfernen
      </ng-container>

    </th>

    <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
      'ktbl-table-content-normal': i % 2 === 0,
      'ktbl-table-content-invert': i % 2 !== 0,
      'ktbl-table-content-border': j === 0,

      'mat-column-cell-first-entry': column === 'VORSCHAU_BILD',
      'ktbl-table-cell-no-padding-left': column === 'VORSCHAU_BILD',

      'ktbl-vertical-align-top': column === 'WERT',
      'ktbl-table-cell-left': column === 'WERT',

      'ktbl-mat-column-cell-add-remove': column === 'ADD' || column === 'REMOVE'
    }">

      <!-- Vorschaubild -->
      <ng-container *ngIf="column === 'VORSCHAU_BILD'">
        <div class="ktbl-mat-column-cell-content">

          <span class="ktbl-bezeichnung-margin">
            {{ entry.bezeichnung }}
          </span>

          <img *ngIf="entry.dateiList?.length > 0 && entry.dateiList[0].datei"
            class="ktbl-mat-column-cell-vorschau-bild-height ktbl-clickable" [src]="entry.dateiList[0].base64Image"
            alt="Fehlendes Bild" (click)="openGallery(entry)" />

        </div>
      </ng-container>

      <!-- Beschreibung -->
      <ng-container *ngIf="column === 'WERT'">

        <span *ngFor="
            let auspraegung of entry.auspraegungGebaeudeUebersicht;
            let last = last
          ">

          {{ auspraegung.modul }}:
          {{ auspraegung.auspraegung }}

          <ng-container *ngIf="auspraegung.wert !== null">

            {{ auspraegung.wert
            | number : '1.0-' + auspraegung.nachkommastellen : 'de-DE'
            }}

            <ng-container *ngIf="auspraegung.dimension !== null">
              {{ auspraegung.dimension }}
            </ng-container>

          </ng-container>

          <ng-container *ngIf="!last"><br></ng-container>

        </span>

      </ng-container>

      <!-- Hinzufügen -->
      <ng-container *ngIf="column === 'ADD'">

        <mat-checkbox [checked]="getAddedStatus(entry.idGebaeude)" (change)="toggleEntry(entry, $event.checked)"
          [matTooltip]="
            getAddedStatus(entry.idGebaeude)
              ? 'Entfernen'
              : 'Hinzufügen'
          " [matTooltipPosition]="position.value" [matTooltipClass]="position.value">
        </mat-checkbox>

      </ng-container>

      <!-- Entfernen -->
      <ng-container *ngIf="column === 'REMOVE'">

        <i (click)="removeEntry(entry)" class="fas fa-trash ktbl-icon-dark" matTooltip="Entfernen"
          [matTooltipPosition]="position.value" [matTooltipClass]="position.value">
        </i>

      </ng-container>

    </td>

  </ng-container>

  <tr mat-header-row class="ktbl-table-header-height-1-row" *matHeaderRowDef="displayedCols">
  </tr>

  <tr mat-row *matRowDef="let row; columns: displayedCols">
  </tr>

</table>